import { FC, useState } from 'react';
import {
	Table,
	Form,
	Row,
	Col,
	Select,
	Input,
	Button,
	Divider,
	Space,
	Progress,
	Flex,
	// Flex,
	// Progress,
} from 'antd';
import { ArrowRightOutlined, FileSearchOutlined } from '@ant-design/icons';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import FleetTitle from '@/libs/antd/components/Title';
import { useApp } from '@/App';
import RequestSLIKModal, { useRequestSLIKModal } from './RequestSLIKModal';
import ViewSLIKModal, { useViewSLIKModal } from './viewSLIKModal';
import ManualSLIKInputModal from './ManualSLIKInputModal';
import {
	getMPPSLIKResult,
	MPPSearchOption,
	SearchMPPCustomerParam,
	useMPPCustomerSearch,
	useMPPSearchOptions,
	// calculateApprovalFlags,
	useRequestMPPSlikMutation,
} from '@/libs/fleet-api/services/mpp';
import { useUserData } from '@/libs/fleet-api/hooks';
import { useModals } from '@/components/modals/ModalProvider';
import { useForm } from '@/libs/antd/form';
import UploadSLIKModal, { useUploadSLIKModal } from './UploadSLIKModal';

const MPPListPage: FC = () => {
	const { modal, openCustomerDetail, openCustomerGroupDetail } = useModals();
	const { navigate } = useApp();
	const { groupName } = useUserData() ?? {};
	const { form, fieldName, value } = useForm<{
		searchBy?: string;
		keyword?: string;
		plafonTypeId?: number;
		financingLimitTypeId?: number;
		spfStatusId?: number;
		customerStatusId?: number;
		applicationStatusId?: number;
	}>();
	// SLIK Modals - Currently using OLD modal (reverted from new simplified modal)
	const uploadSLIKModal = useUploadSLIKModal();
	const requestSLIKModal = useRequestSLIKModal(); // OLD modal - kept for rollback
	const viewSLIKModal = useViewSLIKModal();
	const requestMPPSlikMutation = useRequestMPPSlikMutation();
	const [showManualSLIKModal, setShowManualSLIKModal] = useState(false);
	const [manualSLIKData, setManualSLIKData] = useState<{
		customerId: string;
		mppSlikInquiryId: number;
	} | null>(null);

	// Helper function to check if all robotic SLIK details are "NotFound"
	const isAllRoboticDetailsNotFound = (details: { status: string }[]) => {
		return (
			details.length > 0 &&
			details.every((detail) => detail.status === 'NotFound')
		);
	};

	const [searchParam, setSearchParam] = useState<SearchMPPCustomerParam>({
		pagination: {
			pageNumber: 1,
			pageSize: 10,
		},
	});

	const customerSearchQuery = useMPPCustomerSearch(searchParam);
	const mppSearchOptionQuery = useMPPSearchOptions();
	const searchOption =
		mppSearchOptionQuery.data?.data ?? ({} as MPPSearchOption);

	const dataSource =
		customerSearchQuery.data?.data?.items.map((item, index) => {
			return {
				...item,
				key: index + 1,
			};
		}) ?? [];

	const isLoading =
		customerSearchQuery.isFetching || mppSearchOptionQuery.isFetching;

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<UploadSLIKModal {...uploadSLIKModal} />
			<RequestSLIKModal {...requestSLIKModal} />
			<ViewSLIKModal {...viewSLIKModal} />
			{showManualSLIKModal && manualSLIKData && (
				<ManualSLIKInputModal
					modal={{
						open: showManualSLIKModal,
						onCancel: () => {
							setShowManualSLIKModal(false);
							setManualSLIKData(null);
						},
					}}
					close={() => {
						setShowManualSLIKModal(false);
						setManualSLIKData(null);
					}}
					data={manualSLIKData}
				/>
			)}
			<FleetTitle>Pengajuan Pencairan Pembiayaan</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ flex: 'none', style: { width: 150 } }}
				onFinish={(values: { searchBy?: string; keyword?: string }) => {
					if (
						values?.searchBy === 'customer-name' ||
						values?.searchBy === 'group-bmpp'
					) {
						setSearchParam({
							pagination: searchParam.pagination,
							search:
								values.keyword && values.searchBy
									? {
											by: values!.searchBy!,
											value: values!.keyword!,
										}
									: undefined,
						});
					} else {
						delete values.searchBy;
						setSearchParam({
							pagination: searchParam.pagination,
							...values,
						});
					}
				}}
			>
				<Row gutter={20}>
					<Col flex="none">
						<Form.Item
							name={fieldName('searchBy')}
							initialValue="customer-name"
							label="Kata Kunci"
						>
							<Select
								loading={isLoading}
								disabled={isLoading}
								options={[
									{
										label: 'Nama Customer',
										value: 'customer-name',
									},
									{
										label: 'Group BMPP',
										value: 'group-bmpp',
									},
									...(searchOption.frmOptions?.length
										? [
												{
													label: 'FRM',
													value: 'frmOptions',
												},
											]
										: []),
									...(searchOption.fbdhOptions?.length
										? [
												{
													label: 'FBDH',
													value: 'fbdhOptions',
												},
											]
										: []),
								]}
								style={{ width: 200 }}
							/>
						</Form.Item>
					</Col>
					<Col flex="auto">
						{value?.searchBy === 'customer-name' ||
						value?.searchBy === 'group-bmpp' ? (
							<Form.Item name="keyword">
								<Input
									placeholder="Search"
									disabled={isLoading}
								/>
							</Form.Item>
						) : (
							<Form.Item
								name={
									{
										fbdhOptions: 'fbdhId',
										frmOptions: 'frmId',
									}[value?.searchBy as unknown as string]
								}
							>
								<Select
									loading={isLoading}
									disabled={isLoading}
									options={
										searchOption?.[
											value?.searchBy as keyof MPPSearchOption
										]?.map((data) => {
											return {
												label: data.value,
												value: data.id,
											};
										}) ?? []
									}
									style={{ width: '100%' }}
								/>
							</Form.Item>
						)}
					</Col>
					<Col
						flex="none"
						style={{ width: 190 }}
					>
						<Button
							block
							type="primary"
							htmlType="submit"
							disabled={isLoading}
						>
							SEARCH
						</Button>
					</Col>
				</Row>
			</Form>

			<Divider style={{ margin: 0 }} />

			<Table
				pagination={{
					total: customerSearchQuery.data?.data.totalCount,
					onChange: (pageNumber) => {
						setSearchParam((prev) => ({
							...prev,
							pagination: {
								...prev.pagination,
								pageNumber,
							},
						}));
					},
				}}
				scroll={{ x: 'max-content' }}
				bordered
				loading={isLoading}
				dataSource={dataSource}
				columns={[
					{
						title: 'No',
						align: 'center',
						fixed: 'left',
						render: (_, __, index) => index + 1,
					},
					{
						hidden: groupName === 'FBDH' || groupName === 'CCDH',
						title: 'Customer ID',
						render: (_, record) => record.customerId ?? '-',
					},
					{
						hidden: groupName !== 'FBDH' && groupName !== 'CCDH',
						title: 'No MPP',
						render: (_, record) =>
							record.mppNo ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('MPPPage', {
											mppId: record.mppId,
											onBack: () => {
												navigate('MPPListPage');
											},
											viewOnly: true,
										});
									}}
								>
									{record.mppNo}
								</a>
							) : (
								'-'
							),
					},
					{
						title: 'Nama Customer',
						render: (_, record) =>
							record.customerId ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										openCustomerDetail(record.customerId);
									}}
								>
									{record.customerName}
								</a>
							) : (
								'-'
							),
					},
					{
						title: 'Group BMPP',
						render: (_, record) =>
							record.bmppGroupId ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										openCustomerGroupDetail(record.bmppGroupId);
									}}
								>
									{record.bmppGroupName}
								</a>
							) : (
								'-'
							),
					},
					{
						title: 'FRM',
						hidden:
							groupName !== 'CCDH' &&
							groupName !== 'CCA' &&
							groupName !== 'FBDH',
						render: (_, record) => record.frmUsername ?? '-',
					},
					{
						title: 'FBDH',
						hidden: groupName !== 'CCDH' && groupName !== 'CCA',
						render: (_, record) => record.fbdhUsername ?? '-',
					},
					{
						title: 'CCA',
						hidden: groupName !== 'CCDH',
						render: (_, record) => record.ccaName ?? '-',
					},
					{
						title: 'Status MPP',
						hidden: groupName !== 'CCDH',
						render: (_, record) => record.mppStatus ?? '-',
					},
					{
						hidden:
							groupName !== 'FRM' &&
							groupName !== 'CCA' &&
							groupName !== 'CCDH',
						title: 'SLIK Action',
						align: 'center',
						render: (_, record) => {
							// SLIK Flow Logic based on roles and permissions

							// 1. FRM: Request SLIK Check (Robotic first, fallback to Manual)
							if (groupName === 'FRM' && record.allowSlikRequest) {
								return (
									<a
										onClick={async (e) => {
											e.preventDefault();
											const mppSlikInquiryId = record.mppSlikInquiryId;
											if (
												!mppSlikInquiryId ||
												!record.slikStatus ||
												record.slikStatus === 'CANCELLED'
											) {
												// Check if required files exist

												// Open upload modal to upload missing files
												const uploadResult = await uploadSLIKModal.open({
													customerId: record.customerId,
													slikFormFile: record.slikFormFile,
													applicationLetterFile: record.applicationLetterFile,
												});

												if (uploadResult) {
													// After successful upload, refresh data and proceed
													await customerSearchQuery.refetch();
													await modal.success({
														title: 'Dokumen berhasil diupload',
														subTitle:
															'Sekarang Anda dapat melanjutkan request SLIK',
														okText: 'Lanjutkan Request SLIK',
													});
													return; // Let user click again after files are uploaded
												}
												return; // User cancelled upload
											} else {
												// Use OLD modal for FRM SLIK request
												await requestSLIKModal.open({
													customerId: record.customerId,
													mppSlikInquiryId,
													groupName: 'FRM',
													isReviewing: false,
												});
												customerSearchQuery.refetch();
											}
										}}
										title="Request SLIK Check (Robotic/Manual)"
									>
										<ArrowRightOutlined />
									</a>
								);
							}

							// 2. CCA: Handle SLIK based on type (Robotic or Manual)
							if (groupName === 'CCA' && record.allowCreateSlikRequest) {
								return (
									<a
										onClick={async (e) => {
											e.preventDefault();
											const mppSlikInquiryId = record.mppSlikInquiryId;

											if (!mppSlikInquiryId) {
												await modal.confirm({
													title: 'SLIK Request belum dibuat',
													subTitle:
														'FRM harus membuat request SLIK terlebih dahulu',
													okText: 'OK',
													cancelButtonProps: { style: { display: 'none' } },
												});
												return;
											}

											// Check SLIK result to determine if it's robotic or manual
											const result = await getMPPSLIKResult(mppSlikInquiryId);

											// If robotic SLIK is available (check if not manual and has valid status), show approval options
											if (
												!result.data?.isManualSlik &&
												result.data?.isEnableSlikRobotic &&
												result.data?.roboticSlikRequestResult?.status !==
													'FAILED' &&
												result.data?.roboticSlikRequestResult?.status !==
													'NOTFOUND' &&
												result.data?.roboticSlikRequestResult?.status !==
													'CANCELLED'
											) {
												// if robotic slik is DONE, navigate to HistorySLIKMPPPage for CCA approval
												if (
													result.data.roboticSlikRequestResult?.status ===
													'DONE'
												) {
													navigate('HistorySLIKMPPPage', {
														mppSlikInquiryId,
														isReviewing: true,
														onBack: () => {
															navigate('MPPListPage');
														},
													});
													return;
												}

												if (
													result.data.roboticSlikRequestResult?.status ===
														'REQUESTED' &&
													result.data.roboticSlikRequestResult?.details.length >
														0
												) {
													const slikOnProgress =
														result.data.roboticSlikRequestResult.details.filter(
															(i) => i.status !== 'Requested',
														).length;

													const slikTotal =
														result.data.roboticSlikRequestResult.details.length;

													await modal.confirm({
														title: (
															<span
																style={{
																	fontWeight: 600,
																	fontSize: 16,
																	textAlign: 'center',
																}}
															>
																Proses Pengecekan SLIK sedang berlangsung,{' '}
																<br />
																Mohon tunggu beberapa saat...
															</span>
														),
														subTitle: (
															<Flex
																vertical
																gap={16}
															>
																<div>
																	<span>{slikOnProgress}</span>/
																	<span>{slikTotal}</span>
																</div>
																<div>
																	<Progress
																		showInfo={false}
																		percent={(slikOnProgress / slikTotal) * 100}
																	/>
																</div>
															</Flex>
														),
														cancelButtonProps: { style: { display: 'none' } },
													});

													customerSearchQuery.refetch();
													return;
												}
												// Robotic SLIK - Show approval options
												const action = await modal.confirm({
													title: 'Request SLIK Robotik',
													subTitle:
														'Apakah Anda yakin ingin request SLIK Robotik?',
													okText: 'Request Slik',
													cancelText: 'Cancel',
													okButtonProps: { type: 'primary' },
													cancelButtonProps: { type: 'default' },
												});

												if (action) {
													const res = await requestMPPSlikMutation.mutateAsync(
														record.customerId,
													);

													await modal.success({
														title: 'Reference Number Berhasil Dibuat',
														subTitle: (
															<div style={{ textAlign: 'center' }}>
																Berikut adalah Refference Number Anda:
																<br />
																<strong
																	style={{ fontSize: '18px', color: '#1890ff' }}
																>
																	{res.data.slikInquiryReffNumber ?? '-'}
																</strong>
															</div>
														),
														okText: 'OK',
													});

													// Approve Robotic SLIK
													// await modal.success({
													// 	title: 'SLIK Robotik sedang diproses...',
													// 	subTitle: 'Please wait a moment',
													// 	okText: 'OK',
													// });
												}
											} else {
												// Check if this is the NOTFOUND or CANCELLED case where we force manual SLIK
												const isCancelledCase =
													result.data?.roboticSlikRequestResult?.status ===
														'CANCELLED' &&
													isAllRoboticDetailsNotFound(
														result.data.roboticSlikRequestResult.details,
													);

												const isNotFoundCase =
													result.data?.roboticSlikRequestResult?.status ===
													'NOTFOUND';

												// Determine the appropriate title and subtitle based on the case
												let modalTitle = 'Manual SLIK';
												let modalSubtitle =
													'SLIK Robotic tidak tersedia. Silakan lakukan input Manual SLIK.';

												if (isNotFoundCase) {
													modalTitle = 'SLIK Robotic Not Found';
													modalSubtitle =
														'Hasil SLIK Robotic semua Not Found. Silakan lakukan input Manual SLIK.';
												} else if (isCancelledCase) {
													modalTitle = 'SLIK Robotic Dibatalkan';
													modalSubtitle =
														'SLIK Robotic telah dibatalkan karena melewati batas waktu. Silakan lakukan input Manual SLIK.';
												}

												// Manual SLIK - Either NOTFOUND, CANCELLED case, or no robotic reference number available
												const confirmed = await modal.confirm({
													title: modalTitle,
													subTitle: modalSubtitle,
													okText: 'Input Manual SLIK',
													cancelText: 'Batal',
													okButtonProps: { type: 'primary' },
												});

												if (confirmed) {
													// Navigate to manual SLIK page
													setManualSLIKData({
														customerId: record.customerId,
														mppSlikInquiryId,
													});
													setShowManualSLIKModal(true);
													customerSearchQuery.refetch();
												}
											}
										}}
										title="Handle SLIK (Robotic/Manual)"
									>
										<ArrowRightOutlined
											style={
												record.mppSlikInquiryId
													? { color: '#1557BC' }
													: { color: '#bababa' }
											}
										/>
									</a>
								);
							}

							// 3. CCDH: Final Approval after CCA approval
							if (groupName === 'CCDH' && record.allowApproveSlik) {
								return (
									<a
										onClick={async (e) => {
											e.preventDefault();
											const mppSlikInquiryId = record.mppSlikInquiryId;

											if (!mppSlikInquiryId) {
												await modal.confirm({
													title: 'SLIK Request belum dibuat',
													subTitle:
														'FRM dan CCA harus membuat request SLIK terlebih dahulu',
													okText: 'OK',
													cancelButtonProps: { style: { display: 'none' } },
												});
												return;
											}

											// CCDH Final Approval
											const result = await getMPPSLIKResult(mppSlikInquiryId);

											if (
												result.data.roboticSlikRequestResult.status === 'DONE'
											) {
												navigate('HistorySLIKMPPPage', {
													mppSlikInquiryId,
													isReviewing: true,
													onBack: () => {
														navigate('MPPListPage');
													},
												});
											} else if (result.data.isManualSlik) {
												navigate('HistorySLIKMPPPage', {
													mppSlikInquiryId,
													isReviewing: true,
													onBack: () => {
														navigate('MPPListPage');
													},
												});
											} else {
												await modal.confirm({
													title: 'SLIK Check Belum Selesai',
													subTitle:
														'CCA harus menyelesaikan approval terlebih dahulu',
													okText: 'OK',
													cancelButtonProps: { style: { display: 'none' } },
												});
											}
										}}
										title="CCDH Final Approval"
									>
										<ArrowRightOutlined
											style={
												record.mppSlikInquiryId
													? { color: '#1557BC' }
													: { color: '#bababa' }
											}
										/>
									</a>
								);
							}

							// Default disabled state for SLIK actions
							return <ArrowRightOutlined style={{ color: '#bababa' }} />;
						},
					},
					{
						title: 'View History SLIK',
						align: 'center',
						render: (
							_,
							{ customerId, customerName, bmppGroupId, bmppGroupName },
						) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('HistorySLIKMPPListPage', {
											customerId,
											customerName,
											bmppGroupId,
											bmppGroupName,
										});
									}}
								>
									<FileSearchOutlined />,
								</a>
							);
						},
					},
					{
						title: 'View History MPP',
						align: 'center',
						render: (
							_,
							{ customerId, customerName, bmppGroupId, bmppGroupName },
						) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('HistoryMPPListPage', {
											customerId,
											customerName,
											bmppGroupId,
											bmppGroupName,
										});
									}}
								>
									<FileSearchOutlined />,
								</a>
							);
						},
					},
					{
						hidden: groupName !== 'FRM',
						title: 'Create MPP',
						align: 'center',
						fixed: 'right',
						render: (_, record) => {
							if (!record.allowCreate) {
								return <ArrowRightOutlined style={{ color: '#bababa' }} />;
							}
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('CreateMPPListPage', {
											id: record.customerId,
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							);
						},
					},
					{
						hidden: groupName !== 'CCA',
						title: 'Verifikasi MPP',
						fixed: 'right',
						align: 'center',
						render: (_, record) => {
							// Use enhanced approval logic
							// const approvalState = calculateApprovalFlags(
							// 	record.approverRoleCode || '',
							// 	record.mppStatus || '',
							// 	groupName || '',
							// );

							if (!record.allowCcaVerification) {
								return <ArrowRightOutlined style={{ color: '#bababa' }} />;
							}
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('MPPPage', {
											mppId: record.mppId,
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							);
						},
					},
					{
						hidden: groupName !== 'FBDH' && groupName !== 'CCDH',
						title:
							groupName === 'FBDH' || groupName === 'CCDH'
								? 'Verifikasi MPP'
								: 'Approval MPP',
						align: 'center',
						fixed: 'right',
						render: (_, record) => {
							// Use enhanced approval logic
							// const approvalState = calculateApprovalFlags(
							// 	record.approverRoleCode || '',
							// 	record.mppStatus || '',
							// 	groupName || '',
							// );

							if (!record.allowApprove && groupName === 'FBDH') {
								return <ArrowRightOutlined style={{ color: '#bababa' }} />;
							} else if (
								groupName === 'CCDH' &&
								!record.allowCcdhVerification
							) {
								return <ArrowRightOutlined style={{ color: '#bababa' }} />;
							}

							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										navigate('MPPPage', {
											mppId: record.mppId,
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							);
						},
					},
				]}
			/>
		</Space>
	);
};

export default MPPListPage;
